import HttpCacheItemService from './HttpCacheItemService'
import HttpCacheGroupService from './HttpCacheGroupService'
import calculateExpiresOnValue from './helper/calculateExpiresOnValue'
import getServiceArgsFunction from './helper/getServiceArgsFunction'
import getServiceArgsValue from './helper/getServiceArgsValue'
import { iriFactory } from '../../iri'

const itemService = new HttpCacheItemService(calculateExpiresOnValue, getServiceArgsFunction)
const groupService = new HttpCacheGroupService(itemService, getServiceArgsFunction, getServiceArgsValue, iriFactory)

export default [
  itemService,
  groupService,
]
